<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-card class="ma-10" width="100%" flat tile>
      <v-card-title>
        <h3 class="text-h4">Free Listings</h3>
        <v-spacer></v-spacer>

        <v-btn
          class="mb-auto mr-3"
          @click="toggleAdvanceSearch"
          dark
          fab
          color="secondary"
        >
          <v-icon>mdi-magnify</v-icon></v-btn
        >

        <v-dialog persistent v-model="dialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="modelPermissions.create"
              class="mb-auto"
              dark
              fab
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon></v-btn
            >
          </template>
          <free-listing-dialog
            v-if="dialog"
            :free_listings="free_listings"
            :item="item"
            :close="close"
          ></free-listing-dialog>
        </v-dialog>
      </v-card-title>
      <v-data-table
        :server-items-length="free_listings.total"
        :loading="loading"
        :headers="headers"
        :items="free_listings.data"
        :options.sync="options"
        :items-per-page="5"
      >
        <template v-slot:top>
          <v-expansion-panels disabled multiple v-model="advanceSearch" flat>
            <v-expansion-panel v-for="(item, i) in 1" :key="i">
              <v-expansion-panel-header> </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-toolbar flat>
                    <v-text-field
                      clear-icon
                      clearable
                      v-model.lazy="search"
                      prepend-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-text-field
                      clear-icon
                      clearable
                      v-model.lazy="email"
                      prepend-inner-icon="mdi-email"
                      label="Email"
                      single-line
                    ></v-text-field>
                  </v-toolbar>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <select-categories
                      v-model="category"
                      label="Category"
                    ></select-categories>
                  </v-col>
                  <v-col cols="6">
                    <select-suburbs
                      v-model="suburb"
                      label="Suburb"
                    ></select-suburbs
                  ></v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-if="modelPermissions.edit" v-slot:item.edit="{ item }">
          <v-btn text @click="editItem(item)" color="primary">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
          <v-btn text @click="deleteItem(item)" color="error">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.verified="{ item }">
          <span
            v-if="item.verified === 1"
            class="success--text my-auto font-weight-bold"
            >Y</span
          >

          <span
            v-if="item.verified === 0"
            class="error--text my-auto font-weight-bold"
            >N</span
          >
        </template>

        <template v-slot:item.active="{ item }">
          <span
            v-if="item.active === 1"
            class="success--text my-auto font-weight-bold"
            >Y</span
          >

          <span
            v-if="item.active === 0"
            class="error--text my-auto font-weight-bold"
            >N</span
          >
        </template>
      </v-data-table>
    </v-card>
  </v-row>
</template>

<script>
import FreeListingDialog from './FreeListingDialog'
import SelectSuburbs from '../../../components/SelectSuburbs'
import SelectCategories from '../../../components/SelectCategories'
import axios from '../../../utils/axios'
import { mapGetters } from 'vuex'
export default {
  name: 'FreeListingIndex',
  components: {
    FreeListingDialog,
    SelectCategories,
    SelectSuburbs
  },
  data() {
    return {
      advanceSearch: [],
      dialog: false,
      loading: false,
      headers: [
        {
          text: 'id',
          value: 'id'
        },
        {
          text: 'Name',
          align: 'start',
          value: 'business_name'
        },
        {
          text: 'Email',
          align: 'start',
          value: 'email'
        },
        {
          text: 'Messages Sent',
          align: 'start',
          value: 'text_messages_count'
        },
        { text: 'Edit', align: 'center', value: 'edit', sortable: false },
        { text: 'Delete', align: 'center', value: 'delete', sortable: false },
        {
          text: 'Verified',
          align: 'center',
          value: 'verified',
          sortable: false
        },
        { text: 'Active', align: 'center', value: 'active', sortable: false }
      ],

      free_listings: [],
      options: {},
      item: {},
      search: '',
      email: '',
      category: '',
      suburb: ''
    }
  },

  computed: {
    ...mapGetters(['permissions/getModelPermissions']),
    modelPermissions() {
      return this['permissions/getModelPermissions']('free_listing')
    }
  },
  methods: {
    toggleAdvanceSearch() {
      if (this.advanceSearch.length === 1) {
        this.advanceSearch = []
        this.category = ''
        this.suburb = ''
      } else {
        this.advanceSearch = [0]
      }
    },
    close() {
      this.item = {}
      this.dialog = false
    },
    editItem(item) {
      this.item = item
      this.dialog = true
    },
    getFreeListings() {
      this.loading = true
      console.log('getting freeListing')
      axios
        .get(
          encodeURI(
            `api/admin/free-listings?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${this.search}&email=${this.email}&category=${this.category}&suburb=${this.suburb}`
          )
        )
        .then(res => {
          this.free_listings = res.data
          this.loading = false
          console.log('done')
        })
    },
    deleteItem(item) {
      if (confirm(`Confirm Delete...${item.id}`)) {
        console.log('deleting free listing with id ', item.id)
        axios
          .delete(`api/admin/free-listings/${item.id}`)
          .then(res => {
            console.log(res)
            if (res.data === 1) {
              this.getFreeListings()
            }
          })
          .catch(err => console.log(err))
      }
    }
  },

  watch: {
    options: {
      handler() {
        this.getFreeListings()
      },
      deep: true
    },
    dialog: {
      handler() {
        this.getFreeListings()
      },
      deep: true
    },
    search: {
      handler() {
        this.getFreeListings()
      },
      deep: true
    },
    email: {
      handler() {
        this.getFreeListings()
      },
      deep: true
    },
    category: {
      handler() {
        this.getFreeListings()
      },
      deep: true
    },
    suburb: {
      handler() {
        this.getFreeListings()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
